import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faPenToSquare, faPlus } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export function ArticlesZeroState() {
  return (
    <div className="flex flex-col items-center justify-center h-full p-8 text-center bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800 border-t">
      <div className="relative mb-6">
        <div className="w-24 h-24 rounded-full bg-primary/10 flex items-center justify-center">
          <FontAwesomeIcon
            icon={faPenToSquare}
            className="h-10 w-10 text-primary animate-pulse"
          />
        </div>
        <div className="absolute -top-2 -right-2 w-8 h-8 bg-primary rounded-full flex items-center justify-center animate-bounce">
          <FontAwesomeIcon
            icon={faPlus}
            className="h-4 w-4 text-white"
          />
        </div>
      </div>
      <h3 className="text-xl font-semibold mb-2">
        No articles yet
      </h3>
      <p className="text-muted-foreground mb-6 max-w-md">
        Create your first article to start building your content library.
      </p>
      <Button asChild className="group">
        <Link to="/articles/new">
          Create your first article
          <FontAwesomeIcon
            icon={faArrowRight}
            className="ml-2 h-4 w-4 transform transition-transform group-hover:translate-x-1"
          />
        </Link>
      </Button>
    </div>
  );
}
